<template>
    <div class="setting-style-height d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label
                for="styleBorderRadius"
                class="font-14 m-0"
            >
                Borda Arredondada
            </label>

            <div class="ml-3 d-flex justify-content-center align-items-center">
                <button id="deslock" v-if="isLockStyleBorderRadius" @click="handlerUnlockStyleBorderRadius">
                    <i class="fal fa-lock font-14"></i>
                </button>

                <button id="lock" v-else @click="handlerLockStyleBorderRadius">
                    <i class="fal fa-lock-open font-14"></i>
                </button>
            </div>
        </div>

        <input
            id="styleBorderRadius"
            class="w-100"
            type="range"
            :max="maxValue"
            :min="minValue"
            v-model="styleBorderRadius"
            :disabled="isLockStyleBorderRadius"
        >
    </div>
</template>

<script>
export default {
    name: 'SettingFrameStyleBorderRadius',
    props: {
        item: {
            type: Object,
            required: true
        },
        maxValue: {
            type: String | Number,
            default: 150
        },
    },
    data() {
        return {
            styleBorderRadius: 0,
            minValue: 0,
        }
    },
    methods: {
        onChangeStyleBorderRadius() {
            this.$emit('onChangeStyleBorderRadius', this.item)
        },
        handlerLockStyleBorderRadius() {
            this.$emit('onChangeStyleBorderRadiusLock', true);
        },
        handlerUnlockStyleBorderRadius() {
            this.$emit('onChangeStyleBorderRadiusLock', false);
        },
    },
    computed: {
        isLockStyleBorderRadius() {
            return !!this.item.extra.style_border_radius_lock;
        },
    },
    watch: {
        styleBorderRadius() {
            const styleBorderRadius = `${this.styleBorderRadius}px`;

            this.$emit('onChangeStyleBorderRadius', styleBorderRadius);
        },
    },
    created() {
        this.styleBorderRadius = this.item.extra.style.borderRadius.replace('px', '');
    },
}
</script>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */

   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
   border-radius: 50%;
}

input[type="range"]:focus::-webkit-slider-thumb {   
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

#deslock, #lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleBorderRadius.vue